import React from 'react';

function Footer() {
    return(
        <footer>

            <div className="footer-content">

                            {/* Column 1 */}
                <div className="footer-1">
                        <div className="lists">
                            <ul>
                                <li>
                                    <a href="#">
                                        <p>Main</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <p>About us</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <p>Contacts</p>
                                    </a>
                                </li>
                            </ul>

                            <ul>
                                <li>
                                    <a href="#">
                                        <p>UX/UI</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <p>Usability Testing</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <p>Blog</p>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <p className='copyright'>
                        © Every time you brake copyright rules, Hitler becomes more alive 
                        </p>

                </div> {/* .footer-1 */}

                {/* Column 2 */}
                <div className="footer-2">
                    <ul>
                        <li class='ul-title'>Contact us</li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 0C3.5824 0 0 3.5824 0 8C0 12.4176 3.5824 16 8 16C12.4176 16 16 12.4176 16 8C16 3.5824 12.4176 0 8 0ZM5.67529 12.0938H3.72693V6.23206H5.67529V12.0938ZM4.70117 5.43164H4.68848C4.03467 5.43164 3.61182 4.98157 3.61182 4.41907C3.61182 3.84387 4.04761 3.40625 4.71411 3.40625C5.38062 3.40625 5.79077 3.84387 5.80347 4.41907C5.80347 4.98157 5.38062 5.43164 4.70117 5.43164ZM12.7007 12.0938H10.7526V8.95789C10.7526 8.1698 10.4705 7.63232 9.7655 7.63232C9.22729 7.63232 8.90674 7.99487 8.76587 8.34485C8.71436 8.47009 8.70178 8.64514 8.70178 8.82031V12.0938H6.75354C6.75354 12.0938 6.77905 6.78198 6.75354 6.23206H8.70178V7.06201C8.96069 6.6626 9.42395 6.09448 10.4576 6.09448C11.7395 6.09448 12.7007 6.93225 12.7007 8.73267V12.0938Z" fill="white"/>
                                </svg>

                                </div>
                                <p>LinkedIn</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 16.5333C12.4193 16.5333 16 12.8333 16 8.26667C16 3.70002 12.4193 0 8 0C3.58067 0 0 3.70002 0 8.26667C0 12.8333 3.58067 16.5333 8 16.5333ZM3.66067 8.08755L11.374 5.01442C11.732 4.88078 12.0447 5.10467 11.9287 5.66404L11.9293 5.66335L10.616 12.0569C10.5187 12.5102 10.258 12.6204 9.89333 12.4069L7.89333 10.8838L6.92867 11.8441C6.822 11.9543 6.732 12.0473 6.52533 12.0473L6.66733 9.94411L10.374 6.48382C10.5353 6.33709 10.338 6.25442 10.1253 6.40047L5.54467 9.3806L3.57 8.74407C3.14133 8.60353 3.132 8.30111 3.66067 8.08755Z" fill="white"/>
                                </svg>

                                </div>
                                <p>Telegram</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.002 0H7.998C3.587 0 0 3.588 0 8C0 9.75 0.564 11.372 1.523 12.689L0.526 15.661L3.601 14.678C4.866 15.516 6.375 16 8.002 16C12.413 16 16 12.411 16 8C16 3.589 12.413 0 8.002 0ZM12.657 11.297C12.464 11.842 11.698 12.294 11.087 12.426C10.669 12.515 10.123 12.586 8.285 11.824C5.934 10.85 4.42 8.461 4.302 8.306C4.189 8.151 3.352 7.041 3.352 5.893C3.352 4.745 3.935 4.186 4.17 3.946C4.363 3.749 4.682 3.659 4.988 3.659C5.087 3.659 5.176 3.664 5.256 3.668C5.491 3.678 5.609 3.692 5.764 4.063C5.957 4.528 6.427 5.676 6.483 5.794C6.54 5.912 6.597 6.072 6.517 6.227C6.442 6.387 6.376 6.458 6.258 6.594C6.14 6.73 6.028 6.834 5.91 6.98C5.802 7.107 5.68 7.243 5.816 7.478C5.952 7.708 6.422 8.475 7.114 9.091C8.007 9.886 8.731 10.14 8.99 10.248C9.183 10.328 9.413 10.309 9.554 10.159C9.733 9.966 9.954 9.646 10.179 9.331C10.339 9.105 10.541 9.077 10.753 9.157C10.969 9.232 12.112 9.797 12.347 9.914C12.582 10.032 12.737 10.088 12.794 10.187C12.85 10.286 12.85 10.751 12.657 11.297Z" fill="white"/>
                                </svg>


                                </div>
                                <p>Whatsapp</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 8.26667C16 3.70063 12.4187 0 8 0C3.58125 0 0 3.70063 0 8.26667C0 12.8327 3.58125 16.5333 8 16.5333C8.04688 16.5333 8.09375 16.5333 8.14062 16.5301V10.0976H6.42188V8.02771H8.14062V6.50354C8.14062 4.73719 9.18438 3.7749 10.7094 3.7749C11.4406 3.7749 12.0688 3.82979 12.25 3.85562V5.70271H11.2C10.3719 5.70271 10.2094 6.10958 10.2094 6.70698V8.02448H12.1938L11.9344 10.0944H10.2094V16.2136C13.5531 15.2223 16 12.0416 16 8.26667Z" fill="white"/>
                                </svg>


                                </div>
                                <p>Facebook</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5938 0H1.40627C1.1898 0 0.987146 0.0532189 0.803802 0.140938L7.96878 7.30591L9.57469 5.76257C9.57469 5.76257 9.57481 5.76241 9.57484 5.76235C9.57487 5.76229 9.575 5.76222 9.575 5.76222L15.1965 0.141063C15.0131 0.0532813 14.8103 0 14.5938 0Z" fill="white"/>
                                    <path d="M15.8593 0.803955L10.5692 6.09377L15.8591 11.3837C15.9468 11.2003 16 10.9977 16 10.7812V1.40621C16 1.18986 15.9469 0.987236 15.8593 0.803955Z" fill="white"/>
                                    <path d="M0.140938 0.803223C0.0532188 0.986567 0 1.18922 0 1.40569V10.7807C0 10.997 0.0531563 11.1997 0.140813 11.383L5.43091 6.09319L0.140938 0.803223Z" fill="white"/>
                                    <path d="M9.90634 6.75641L8.30021 8.29994C8.20865 8.3915 8.08871 8.43729 7.96881 8.43729C7.8489 8.43729 7.72893 8.3915 7.6374 8.29994L6.09377 6.75635L0.803581 12.0462C0.986956 12.134 1.18974 12.1873 1.40627 12.1873H14.5938C14.8102 12.1873 15.0129 12.134 15.1962 12.0463L9.90634 6.75641Z" fill="white"/>
                                </svg>




                                </div>
                                <p>ilove@opium.pro</p>
                            </a>
                        </li>
                    </ul>

                    <ul>
                        <li class='ul-title'>Follow us</li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.242 6.96467C8.242 5.73267 7.656 4.822 6.44533 4.48067C7.32867 4.06 7.78933 3.42267 7.78933 2.43133C7.78933 0.476667 6.328 0 4.642 0H0V9.814H4.772C6.56133 9.814 8.242 8.95866 8.242 6.96467ZM2.164 1.67533H4.19467C4.97533 1.67533 5.678 1.894 5.678 2.79667C5.678 3.63 5.13133 3.96533 4.358 3.96533H2.164V1.67533ZM2.16333 8.14733V5.44467H4.522C5.47467 5.44467 6.07733 5.84067 6.07733 6.846C6.07733 7.83733 5.358 8.14733 4.47733 8.14733H2.16333Z" fill="white"/>
                                    <path d="M12.5307 9.99994C14.2333 9.99994 15.336 9.23528 15.8667 7.60994H14.1387C13.9527 8.21661 13.186 8.53728 12.5913 8.53728C11.444 8.53728 10.8413 7.86728 10.8413 6.72861H15.9833C15.992 6.61328 16 6.48861 16 6.36394C16 4.26194 14.7667 2.50928 12.5307 2.50928C10.358 2.50928 8.88333 4.13728 8.88333 6.26994C8.88266 8.48194 10.28 9.99994 12.5307 9.99994ZM12.4693 3.98261C13.4527 3.98261 13.9473 4.55861 14.03 5.50061H10.844C10.9087 4.56661 11.5307 3.98261 12.4693 3.98261Z" fill="white"/>
                                    <path d="M10.4446 0.514893H14.4366V1.48156H10.4446V0.514893Z" fill="white"/>
                                </svg>



                                </div>
                                <p>Behance</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.6703 1.73327C15.486 1.05551 14.9455 0.521237 14.2602 0.338737C13.0081 0 7.99982 0 7.99982 0C7.99982 0 2.9917 0 1.73965 0.325894C1.06748 0.508202 0.513868 1.05561 0.329493 1.73327C0 2.97119 0 5.53846 0 5.53846C0 5.53846 0 8.11867 0.329493 9.34365C0.514063 10.0213 1.0543 10.5556 1.73975 10.7381C3.00489 11.0769 8.00002 11.0769 8.00002 11.0769C8.00002 11.0769 13.0081 11.0769 14.2602 10.751C14.9456 10.5686 15.486 10.0344 15.6705 9.35669C15.9999 8.11867 15.9999 5.5515 15.9999 5.5515C15.9999 5.5515 16.0131 2.97119 15.6703 1.73327ZM6.40529 7.9102V3.16673L10.5699 5.53846L6.40529 7.9102Z" fill="white"/>
                                </svg>


                                </div>
                                <p>Youtube</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.59999 8.53323C9.59999 9.4169 8.88367 10.1332 7.99999 10.1332C7.11632 10.1332 6.39999 9.4169 6.39999 8.53323C6.39999 7.64955 7.11632 6.93323 7.99999 6.93323C8.88367 6.93323 9.59999 7.64955 9.59999 8.53323Z" fill="white"/>
                                    <path d="M11.55 5.84726C11.477 5.64953 11.3606 5.47056 11.2093 5.32366C11.0624 5.17239 10.8836 5.05598 10.6857 4.98301C10.5253 4.92069 10.2842 4.84651 9.84022 4.8263C9.35993 4.8044 9.21593 4.79968 8.00003 4.79968C6.784 4.79968 6.64 4.80428 6.15983 4.82618C5.71585 4.84651 5.47467 4.92069 5.31433 4.98301C5.11648 5.05598 4.93751 5.17239 4.79073 5.32366C4.63946 5.47056 4.52305 5.64941 4.44996 5.84726C4.38764 6.00772 4.31346 6.2489 4.29325 6.69288C4.27135 7.17305 4.26663 7.31705 4.26663 8.53308C4.26663 9.74898 4.27135 9.89298 4.29325 10.3733C4.31346 10.8173 4.38764 11.0583 4.44996 11.2188C4.52305 11.4166 4.63934 11.5955 4.7906 11.7424C4.93751 11.8936 5.11636 12.0101 5.31421 12.083C5.47467 12.1455 5.71585 12.2196 6.15983 12.2398C6.64 12.2618 6.78388 12.2663 7.9999 12.2663C9.21605 12.2663 9.36005 12.2618 9.8401 12.2398C10.2841 12.2196 10.5253 12.1455 10.6857 12.083C11.0829 11.9298 11.3968 11.6159 11.55 11.2188C11.6123 11.0583 11.6865 10.8173 11.7068 10.3733C11.7287 9.89298 11.7333 9.74898 11.7333 8.53308C11.7333 7.31705 11.7287 7.17305 11.7068 6.69288C11.6866 6.2489 11.6124 6.00772 11.55 5.84726ZM8.00003 10.8713C6.70849 10.8713 5.66151 9.82449 5.66151 8.53296C5.66151 7.24142 6.70849 6.19456 8.00003 6.19456C9.29144 6.19456 10.3384 7.24142 10.3384 8.53296C10.3384 9.82449 9.29144 10.8713 8.00003 10.8713ZM10.4309 6.64859C10.1291 6.64859 9.88439 6.40391 9.88439 6.10211C9.88439 5.80031 10.1291 5.55563 10.4309 5.55563C10.7327 5.55563 10.9774 5.80031 10.9774 6.10211C10.9772 6.40391 10.7327 6.64859 10.4309 6.64859Z" fill="white"/>
                                    <path d="M8 0C3.5824 0 0 3.70181 0 8.26667C0 12.8315 3.5824 16.5333 8 16.5333C12.4176 16.5333 16 12.8315 16 8.26667C16 3.70181 12.4176 0 8 0ZM12.566 10.2237C12.5438 10.729 12.4661 11.074 12.3525 11.376C12.1139 12.0136 11.6261 12.5177 11.009 12.7643C10.7169 12.8816 10.3829 12.9618 9.89404 12.9849C9.40417 13.008 9.24768 13.0135 8.00012 13.0135C6.75244 13.0135 6.59607 13.008 6.10608 12.9849C5.61719 12.9618 5.2832 12.8816 4.99109 12.7643C4.68445 12.6451 4.40686 12.4583 4.17737 12.2167C3.94373 11.9797 3.76294 11.6927 3.64758 11.376C3.53406 11.0741 3.4563 10.729 3.43408 10.2238C3.4115 9.71752 3.40625 9.55581 3.40625 8.26667C3.40625 6.97752 3.4115 6.81581 3.43396 6.30961C3.45618 5.8043 3.53381 5.45931 3.64734 5.15733C3.7627 4.8406 3.9436 4.55363 4.17737 4.31661C4.40674 4.07506 4.68445 3.88824 4.99097 3.76904C5.2832 3.65173 5.61707 3.57151 6.10608 3.54843C6.59595 3.52534 6.75244 3.51979 8 3.51979C9.24756 3.51979 9.40405 3.52534 9.89392 3.54855C10.3829 3.57151 10.7168 3.65173 11.009 3.76892C11.3156 3.88812 11.5933 4.07506 11.8228 4.31661C12.0564 4.55376 12.2373 4.8406 12.3525 5.15733C12.4662 5.45931 12.5438 5.8043 12.5662 6.30961C12.5885 6.81581 12.5938 6.97752 12.5938 8.26667C12.5938 9.55581 12.5885 9.71752 12.566 10.2237Z" fill="white"/>
                                </svg>



                                </div>
                                <p>Instagram</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.7233 1.45581L16 0.261433V0H11.5773L8.42533 7.67218L4.83933 0H0.202V0.261433L1.69333 2.01714C1.83867 2.14688 1.91467 2.3366 1.89533 2.52762V9.42723C1.94133 9.67563 1.85867 9.93119 1.68 10.1118L0 12.1028V12.361H4.76333V12.0996L3.08333 10.1118C2.90133 9.93054 2.81533 9.67954 2.852 9.42723V3.45926L7.03333 12.3643H7.51933L11.1147 3.45926V10.5532C11.1147 10.7403 11.1147 10.7787 10.9893 10.9013L9.696 12.125V12.3871H15.9707V12.1257L14.724 10.9319C14.6147 10.8511 14.558 10.7155 14.5813 10.5838V1.80395C14.558 1.67161 14.614 1.536 14.7233 1.45581Z" fill="white"/>
                                </svg>


                                </div>
                                <p>Medium</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="icon">

                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 0V16.2319H10.5275L10.5275 10.2493H5.47246V16.2319H0L0 0L5.47246 0V5.75072L10.5275 5.75072V0L16 0Z" fill="white"/>
                                </svg>


                                </div>
                                <p>Habr</p>
                            </a>
                        </li>
                    </ul>
                </div> {/* .footer-2 */}

            </div>

        </footer>
    )
}

export default Footer;